import type { ReactNode } from "react";
import { Outlet } from "react-router";
import { Icon } from "../../ui/Icon";
import { brand, Logo } from "../brand";
import styles from "./PublicLayout.module.css";

/**
 * Login/signup card layout: promo half on the left at desktop widths, the 400px card on the right.
 * The promo is the clone's own copy: Clockify's CAKE.com artwork is not reused.
 */
export function PublicLayout({ children }: { children?: ReactNode }) {
  return (
    <div className={styles.page}>
      <aside className={styles.promo} aria-hidden="true">
        <div className={styles.promoInner}>
          <p className={styles.promoKicker}>Time tracking</p>
          <p className={styles.promoTitle}>Every feature. Free.</p>
          <p className={styles.promoText}>Timesheets, reports, scheduling, invoicing and more, for your whole team.</p>
        </div>
      </aside>
      <div className={styles.side}>
        <div className={styles.card}>
          <div className={styles.cardHeader}>
            <Logo size={40} />
          </div>
          <div className={styles.cardBody}>{children ?? <Outlet />}</div>
          <div className={styles.cardFooter}>{brand.productName}</div>
        </div>
        <div className={styles.language}>
          <Icon name="languages" size={20} />
          English
        </div>
      </div>
    </div>
  );
}
